import { dataFetcher, fileUploader } from 'core/services/requestHandler';   

const getBannerImageFileNames = async (data = {}, config = {}) => {
  return dataFetcher('settings/getBannerImageFileNames', data, { ...config});
};

const deleteBannerImage = async (data = {}, config = {}) => {
  return dataFetcher('settings/deleteBannerImage', data, { method: 'POST', ...config});
};

const uploadBannerImage = async (data = {}, config = {}) => {
  return fileUploader('settings/uploadBannerImage', data, { method: 'POST', ...config});
};

export { getBannerImageFileNames, deleteBannerImage, uploadBannerImage };
